<script setup lang="ts">
  import type { SliderRootEmits, SliderRootProps } from "reka-ui";
  import type { HTMLAttributes } from "vue";
  import { reactiveOmit } from "@vueuse/core";
  import { SliderRange, SliderRoot, SliderThumb, SliderTrack, useForwardPropsEmits } from "reka-ui";
  import { cn } from "@/lib/utils";

  const props = defineProps<SliderRootProps & { class?: HTMLAttributes["class"] }>();
  const emits = defineEmits<SliderRootEmits>();

  const delegatedProps = reactiveOmit(props, "class");
  const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <SliderRoot
    data-slot="slider"
    v-bind="forwarded"
    :class="
      cn(
        'relative flex w-full touch-none select-none items-center data-[orientation=vertical]:h-full data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col',
        props.class,
      )
    ">
    <SliderTrack
      data-slot="slider-track"
      class="bg-primary/20 relative h-1.5 w-full grow overflow-hidden rounded-full data-[orientation=vertical]:w-1.5">
      <SliderRange
        data-slot="slider-range"
        class="bg-primary absolute h-full data-[orientation=vertical]:w-full" />
    </SliderTrack>
    <SliderThumb
      v-for="(_, key) in props.modelValue"
      :key="key"
      data-slot="slider-thumb"
      class="border-primary bg-background ring-offset-background focus-visible:ring-ring block size-4 shrink-0 rounded-full border shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
  </SliderRoot>
</template>
